// extracted by mini-css-extract-plugin
export var square = "styles-module--square--c8ad4";
export var square1 = "styles-module--square1--9d393";
export var square2 = "styles-module--square2--0543e";
export var square3 = "styles-module--square3--fb04b";
export var square4 = "styles-module--square4--f0a64";